/* eslint-disable complexity */
/* eslint-disable camelcase */
import { formatDate } from '@angular/common';
import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { TextMaskConfig } from 'angular2-text-mask/src/angular2TextMask';
import * as moment from 'moment';
import { forkJoin, Observable } from 'rxjs';
import { ErrorList } from '../../../../shared-components/controls/error-prompt/error-list.model';
import { Lookup } from '../../../../shared-components/lookup/lookup.model';
import { SecurityService } from '../../../../shared-components/security/security.service';
import { System } from '../../../../shared-components/System';
import { UserPreferencesService } from '../../../../shared-components/user-preferences/user-preferences.service';
import { SchoolYearSettings } from '../../../../shared-components/year/school-year-settings.model';
import { YearService } from '../../../../shared-components/year/year.service';
import { LoginService } from '../../../../shared-modules/login/login.service';
import { CourseTerm } from '../../../../student360/student-schedule/course-term.model';
import { StudentAttachment } from '../../../student-attachment/student-attachment.model';
import { ReportParameterV9 } from '../../models/report-parameter-v9.model';
import { ReportV9 } from '../../models/report-v9.model';
import { TeacherPreview } from '../../models/teacher-preview.model';
import { ReportQueueComponent } from '../../report-queue/report-queue.component';
import { ReportingService } from '../../reporting.service';

@Component({
  selector: 'app-manual-entry-rosters',
  templateUrl: './manual-entry-rosters.component.html',
  styleUrls: ['./manual-entry-rosters.component.css'],
})
export class ManualEntryRostersComponent implements OnInit, OnDestroy {
  schoolYearSettings: SchoolYearSettings;
  userPreferences: any;
  reportParameter = new ReportParameterV9();
  thisDialogRef: MatDialogRef<ManualEntryRostersComponent>;
  term: CourseTerm;
  dataSource: MatTableDataSource<TeacherPreview>;
  gridColumns: string[] = ['SelectAll', 'AbbreviatedTitle', 'TeacherName', 'Period', 'TermCode', 'DepartmentCode', 'SubjectCode', 'Section', 'RoomNumber', 'DaysGroupDescription'];
  report: ReportV9;
  ErrorCount: 0;
  parameters = [];
  param = [];
  // ERROR HANDLING
  // form: Form;
  errors: ErrorList[] = [];
  exportCLick = false;
  public numberMask: TextMaskConfig;
  @ViewChild('Week1Date', { read: ElementRef, static: true }) week1Date: ElementRef;
  @ViewChild('Week2Date', { read: ElementRef, static: true }) week2Date: ElementRef;
  @ViewChild('Select', { read: ElementRef }) select: ElementRef;
  @ViewChild('FromPeriod', { read: ElementRef, static: true }) fromPeriod: ElementRef;
  @ViewChild('ToPeriod', { read: ElementRef, static: true }) toPeriod: ElementRef;
  isDataExist = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    ManualEntryRostersDialogRef: MatDialogRef<ManualEntryRostersComponent>,
    private dialog: MatDialog,
    private loginService: LoginService,
    private yearService: YearService,
    private userPreferencesService: UserPreferencesService,
    private reportingService: ReportingService,
    private securityService: SecurityService
  ) {
    this.thisDialogRef = ManualEntryRostersDialogRef;
    this.report = data.Report;
  }

  ngOnInit() {
    this.numberMask = this.reportingService.getNumberMask();
    this.initialize();

  }
  ngOnDestroy() {

  }

  initialize() {
    const serverCalls: Observable<any> = forkJoin(
      this.userPreferencesService.getUserPreferences(0, '/ManualEntryRosters.aspx'),
      this.reportingService.getTermsforCourses(0, this.yearService.defaultYear.SiteYearId),
      this.reportingService.getDynamicPagesReadForStudentLookup(false),
      this.yearService.getSchoolYearSettings(this.yearService.defaultYear.Id, this.yearService.defaultYear.SchoolID)
    );

    serverCalls.subscribe(results => {
      if (results[0] != null) {
        if (results[0].length == 1) {
          this.getUserPreferences(results[0][0]);
        }
      }
      if (results[1] != null) {
        this.getTerms(results[1]);
      }
      if (results[2] != null) {
        this.getDynamicPagesReadForStudentLookup(results[2]);
      }
      if (results[3] != null) {
        this.getSchoolYearSettings(results[3]);
      }
    });
  }

  getUserPreferences(userPreferences: string) {
    this.userPreferences = JSON.parse(userPreferences);
    if (this.userPreferences != null) {
      this.reportParameter.radValue = (this.userPreferences.pub_blnPrintNoField ? 'radNoField' : (this.userPreferences.pub_blnPrintStudentId ? 'radPrintStudentID' : 'radOtherField'));
      this.reportParameter.SkipLineBetweenStudent = this.userPreferences.pub_blnSkipLinesBetweenStudent;
      this.reportParameter.PrintWithGreyHeading = this.userPreferences.pub_blnPrintWithGreyHeadings;
      this.reportParameter.PrintStudentAbsencesAlreadyEntered = this.userPreferences.pub_blnPrintStudentAbsencesAlreadyEntered;
      this.reportParameter.PrintTeacherSignatureLine = this.userPreferences.pub_blnPrintTeacherSignatureLine;
      this.reportParameter.blnCalledFrom360 = this.userPreferences.pub_blnCalledFrom360;
      if (this.reportParameter.OtherFields != null && this.userPreferences.pub_strOtherField != '') {
        this.reportParameter.OtherField = this.userPreferences.pub_strOtherField;
      }
    }
  }
  getTerms(terms: CourseTerm[]) {
    this.reportParameter.Terms = terms.filter(function (element) { return (element.TermTypeId != 2); });
    this.term = new CourseTerm();
    this.term.Id = -1;
    this.term.LongDescription = ' Today\'s Only';
    this.reportParameter.Terms.push(this.term);
    this.term = new CourseTerm();
    this.term.Id = 0;
    this.term.LongDescription = ' All Terms';
    this.reportParameter.Terms.push(this.term);
  }
  getDynamicPagesReadForStudentLookup(otherFields: Lookup[]) {
    this.reportParameter.OtherFields = otherFields;
    if (otherFields.length > 0) {
      this.reportParameter.OtherField = otherFields[0].Id;
      if (this.userPreferences != null) {
        if (this.userPreferences.pub_strOtherField != '') {
          this.reportParameter.OtherField = this.userPreferences.pub_strOtherField.toString();
        }
      }
    }
  }
  getSchoolYearSettings(schoolYearSettings: SchoolYearSettings) {
    this.schoolYearSettings = schoolYearSettings;
    this.reportParameter.isValueChange = false;
    this.reportParameter.isReportList = false;
    this.reportParameter.PrintDate = formatDate(new Date, 'MM/dd/yyyy', 'en-US');
    this.reportParameter.AttendanceDate = moment(this.yearService.defaultYear.CurrentAttendanceDate).format('MM/DD/YYYY');
    this.reportParameter.FromPeriod = this.schoolYearSettings.MinumumPeriodPerDay;
    this.reportParameter.ToPeriod = this.schoolYearSettings.MaximumPeriodsPerDay;
    const weekDay = moment.utc(this.reportParameter.AttendanceDate, 'MM/DD/YYYY').toDate().getDay();
    this.reportParameter.Week1Date = moment(this.yearService.defaultYear.CurrentAttendanceDate).subtract(weekDay, 'days').format('MM/DD/YYYY');
    this.reportParameter.Week2Date = moment(this.yearService.defaultYear.CurrentAttendanceDate).add(-weekDay + 7, 'days').format('MM/DD/YYYY');
    this.setReportTitle();
    this.reportParameter.TermId = -1;
    this.refreshGrid();
  }
  setReportTitle() {
    if (this.loginService.LoginSettings.State != 'CA') {
      if (moment(this.reportParameter.Week1Date).isValid() && moment(this.reportParameter.Week2Date).isValid()) {
        this.reportParameter.ReportTitle = 'Weeks of: ' + moment.utc(this.reportParameter.Week1Date).format('MM/DD/YYYY') + ' and ' + moment.utc(this.reportParameter.Week2Date).format('MM/DD/YYYY');
      }
    } else {
      this.reportParameter.ReportTitle = 'Attendance Roster Verification';
    }
  }

  changeValue() {
    this.reportParameter.isValueChange = true;
    if (this.reportParameter.FromPeriod > this.schoolYearSettings.MaximumPeriodsPerDay || this.reportParameter.FromPeriod < this.schoolYearSettings.MinumumPeriodPerDay) {
      this.reportParameter.FromPeriod = this.schoolYearSettings.MinumumPeriodPerDay;
    }
    if (this.reportParameter.ToPeriod > this.schoolYearSettings.MaximumPeriodsPerDay || this.reportParameter.ToPeriod < this.schoolYearSettings.MinumumPeriodPerDay) {
      this.reportParameter.ToPeriod = this.schoolYearSettings.MaximumPeriodsPerDay;
    }
  }
  cancelShowReportParameters() {
    this.thisDialogRef.close();
  }

  refreshGrid() {
    this.errors = [];
    if ((this.reportParameter.FromPeriod == undefined || this.reportParameter.FromPeriod == 0 || this.reportParameter.FromPeriod == null) && $.isNumeric(this.reportParameter.FromPeriod) == false) {
      this.errors.push({
        fieldName: 'From Period',
        errorMsg: 'Field is required',
        fieldRef: this.fromPeriod
      });
    }
    if ((this.reportParameter.ToPeriod == undefined || this.reportParameter.ToPeriod == 0 || this.reportParameter.ToPeriod == null) && $.isNumeric(this.reportParameter.ToPeriod) == false) {
      this.errors.push({
        fieldName: 'To Period',
        errorMsg: 'Field is required',
        fieldRef: this.toPeriod
      });
    }
    if (this.errors.length == 0) {
      this.reportParameter.ReportGridData = [];
      this.reportingService.getTeacherPreviewGridData(this.yearService.defaultYear.SiteYearId, this.reportParameter.TermId, moment.utc(this.reportParameter.AttendanceDate, 'MM-DD-YYYY HH:mm a').toDate(), this.reportParameter.FromPeriod, this.reportParameter.ToPeriod).subscribe(results => {
        this.reportParameter.ReportGridData = results;
        if (this.reportParameter.ReportGridData.length > 0) {
          this.isDataExist = true;
        }
        else {
          this.isDataExist = false;
        }
        this.reportParameter.isValueChange = false;
        this.dataSource = new MatTableDataSource(this.reportParameter.ReportGridData);
        this.reportParameter.selectAllReportGridData = true;
        this.selectAll(true);
      });
    }
  }

  selectAll(value) {
    this.reportParameter.ReportGridData.forEach(o => {
      o.Select = value;
    }
    );
  }

  selectClass() {
    const result = this.reportParameter.ReportGridData.filter(o => o.Select == false);
    if (result.length > 0) {
      this.reportParameter.selectAllReportGridData = false;
    }
    else if (result.length == 0) {
      this.reportParameter.selectAllReportGridData = true;
    }
  }

  runClick() {
    let backgroundColor = '';
    this.errors = [];
    if (this.reportParameter.PrintWithGreyHeading) {
      backgroundColor = '#bbbec1';
    }
    const selectedGridData = this.reportParameter.ReportGridData.filter(o => o.Select);
    if (selectedGridData.length == 0) {
      this.errors.push({
        fieldName: '',
        errorMsg: 'No Rosters Selected!',
        fieldRef: this.select
      });
    }
    if (this.reportParameter.isValueChange) {
      this.errors.push({
        fieldName: '',
        errorMsg: '<span><a style="cursor:pointer;text-decoration:underline;text-wrap:none;white-space: nowrap;">Selection Criteria Changed </a>  Please click Update Display button again!<span>',
        fieldRef: null
      });
    }
    if (this.reportParameter.Week1Date == undefined || this.reportParameter.Week1Date == '' || this.reportParameter.Week1Date == null) {
      this.errors.push({
        fieldName: 'Week1',
        errorMsg: 'Field is required',
        fieldRef: this.week1Date
      });
    }

    if (this.reportParameter.Week2Date == undefined || this.reportParameter.Week2Date == '' || this.reportParameter.Week2Date == null) {
      this.errors.push({
        fieldName: 'Week2',
        errorMsg: 'Field is required',
        fieldRef: this.week2Date
      });
    }
    if (this.errors.length == 0) {
      let sectionIds = '';
      selectedGridData.forEach((el, i) => {
        if (sectionIds == '') {
          sectionIds += selectedGridData[i].SiteSectionId;
        } else {
          sectionIds = sectionIds + ',' + selectedGridData[i].SiteSectionId;
        }
      });


      let workflowReport = false;
      if (selectedGridData.length >= 5) {
        workflowReport = true;
      }

      const userPermissions = this.securityService.userPermissions;
      let viewSSN = false;
      let viewStudentPortalId = false;
      let viewReleaseAlert = false;
      let viewLunchStatus = false;
      let viewStudentFields = false;
      if (userPermissions != null) {
        if (userPermissions.filter(o => o.PermissionCode == 'GO_VSSSN').length > 0) {
          viewSSN = true;
        }
        if (userPermissions.filter(o => o.PermissionCode == 'SD_VPPP').length > 0) {
          viewStudentPortalId = true;
        }
        if (userPermissions.filter(o => o.PermissionCode == 'SD_VSRA').length > 0) {
          viewReleaseAlert = true;
        }
        if (userPermissions.filter(o => o.PermissionCode == 'GO_VSFRS').length > 0) {
          viewLunchStatus = true;
        }
        if (userPermissions.filter(o => o.PermissionCode == 'SR_VSF').length > 0) {
          viewStudentFields = true;
        }
      }

      this.saveUserPreferences();
      this.parameters = [];
      this.param = [];
      this.param.push({ ParamName: 'strReportDate', ParamStringValue: this.reportParameter.PrintDate });
      this.param.push({ ParamName: 'strReportSiteHeader', ParamStringValue: this.yearService.defaultYear.SchoolName });
      this.param.push({ ParamName: 'strReportTitle', ParamStringValue: this.reportParameter.ReportTitle });
      this.param.push({ ParamName: 'strSiteYearCode', ParamStringValue: this.yearService.defaultYear.SchoolCode + '' + this.yearService.defaultYear.AYIdentifier });
      this.param.push({ ParamName: 'lngSiteYearId', ParamStringValue: this.yearService.defaultYear.SiteYearId });
      this.param.push({ ParamName: 'strSiteSectionIds', ParamStringValue: sectionIds });
      this.param.push({ ParamName: 'datWeek1', ParamStringValue: moment.utc(this.reportParameter.Week1Date).format('MM/DD/YYYY') });
      this.param.push({ ParamName: 'datWeek2', ParamStringValue: moment.utc(this.reportParameter.Week2Date).format('MM/DD/YYYY') });
      this.param.push({ ParamName: 'blnPrintStudentId', ParamStringValue: (this.reportParameter.radValue == 'radPrintStudentID' ? true : false) });
      this.param.push({ ParamName: 'strOtherField', ParamStringValue: (this.reportParameter.radValue == 'radOtherField' ? this.reportParameter.OtherField : '') });
      this.param.push({ ParamName: 'blnSkipLinesBetweenStudent', ParamStringValue: this.reportParameter.SkipLineBetweenStudent });
      this.param.push({ ParamName: 'blnPrintGray', ParamStringValue: this.reportParameter.PrintWithGreyHeading });
      this.param.push({ ParamName: 'strBackgroundColor', ParamStringValue: backgroundColor });
      this.param.push({ ParamName: 'blnPrintStudentAbsencesAlreadyEntered', ParamStringValue: this.reportParameter.PrintStudentAbsencesAlreadyEntered });
      this.param.push({ ParamName: 'blnPrintTeacherSignatureLine', ParamStringValue: this.reportParameter.PrintTeacherSignatureLine });
      this.param.push({ ParamName: 'blnViewSSN', ParamStringValue: viewSSN });
      this.param.push({ ParamName: 'blnViewStudentPortalId', ParamStringValue: viewStudentPortalId });
      this.param.push({ ParamName: 'blnViewReleaseAlert', ParamStringValue: viewReleaseAlert });
      this.param.push({ ParamName: 'blnViewLunchStatus', ParamStringValue: viewLunchStatus });
      this.param.push({ ParamName: 'blnViewStudentFields', ParamStringValue: viewStudentFields });
      this.param.push({ ParamName: 'blnCalledFrom360', ParamStringValue: true });
      if(this.exportCLick){
        this.param.push({ ParamName: 'Export', ParamStringValue: true });
        this.param.push({ ParamName: 'blnIncludeAbsences', ParamStringValue: '0' });
      }
      this.parameters.push(JSON.stringify(this.param));
      if (workflowReport) {
        this.reportingService.runV9Report(this.report.ReportName, this.report.ReportType, workflowReport, this.parameters).subscribe(response => {
          setTimeout(() => {
            this.reportQueueList();
          }, 500);
        }
          , err => {
            // On Error
            console.log(err);
          });
      } else {
        const studentAttachment: StudentAttachment = {
          DocumentId: 0,
          DocumentName: this.report.ReportName,
          DocumentBase64: '',
          DocumentMimeType: '',
          DocumentModuleName: '',
          ReportParameters: this.parameters,
          ReportType: this.report.ReportType
        };
        window.localStorage.setItem('studentAttachment', JSON.stringify(studentAttachment));
        window.localStorage.removeItem('v9ReportParameter_exportTXT');
        if (this.exportCLick == true) {
            window.localStorage.setItem('v9ReportParameter_exportTXT', this.report.ReportName + '_' + new Date().toLocaleDateString());
        }
        window.open(System.baseUrl + 'studentattachment', '_blank');
      }
      this.thisDialogRef.close();
    }
  }
  saveUserPreferences() {
    const UserPreferencesObj = this.userPreferences;
    UserPreferencesObj.pub_blnPrintNoField = (this.reportParameter.radValue == 'radNoField' ? true : false);
    UserPreferencesObj.pub_blnPrintStudentId = (this.reportParameter.radValue == 'radPrintStudentID' ? true : false);
    UserPreferencesObj.pub_blnPrintOtherField = (this.reportParameter.radValue == 'radOtherField' ? true : false);
    if (this.reportParameter.OtherField != '') {
      UserPreferencesObj.pub_strOtherField = this.reportParameter.OtherField;
    }
    UserPreferencesObj.pub_blnSkipLinesBetweenStudent = this.reportParameter.SkipLineBetweenStudent;
    UserPreferencesObj.pub_blnPrintWithGreyHeadings = this.reportParameter.PrintWithGreyHeading;
    UserPreferencesObj.pub_blnPrintStudentAbsencesAlreadyEntered = this.reportParameter.PrintStudentAbsencesAlreadyEntered;
    UserPreferencesObj.pub_blnPrintTeacherSignatureLine = this.reportParameter.PrintTeacherSignatureLine;
    UserPreferencesObj.pub_blnCalledFrom360 = this.reportParameter.blnCalledFrom360;
    const xmlStream: string[] = [];
    xmlStream.push(JSON.stringify(UserPreferencesObj));
    this.userPreferencesService.saveUserPreferences(0, '/ManualEntryRosters.aspx', xmlStream, 0, '').subscribe(response => { }
      , err => {
        // On Error
        console.log(err);
      });
  }
  reportQueueList() {
    const reportQueueDialogRef = this.dialog.open(ReportQueueComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
    });
  }
}